module.exports = __webpack_public_path__ + "img/position_title_bag.cac562c7.png";